import { OperationCarl } from './operation-carl.entity';
import { AccesOperationTLR } from './acces-operation-tlr.entity';

export class AccesOperation extends AccesOperationTLR {
	
	ouvrageNom!: string;
	codeActe!: string;

	constructor(accesId: number, acteId: number, createdByAurora: boolean, operation: OperationCarl,
		numero: string, sequence: number, ouvrageNom: string, codeActe: string) {
		super();
		this.accesId = accesId;
		this.ouvrageId = operation.idOuvrage;
		this.codeCarl = operation.refOperationCarl;
		this.boxLocation = operation.refOuvrageDansCarl ? operation.refOuvrageDansCarl : "";
		this.descriptionOperation = operation.intitule;
		this.acteOnmId = acteId;
		this.etat = operation.statut;
		this.dateDebut = operation.dateDebut;
		this.dateFin = operation.dateFin;
		this.createdByAurora = createdByAurora;
		this.numero = numero;
		this.sequence = sequence;
		this.ouvrageNom = ouvrageNom;
		this.codeActe = codeActe;
	}

}